export const getInternalComments = state => state.internalComment.commentList;
export const getInternalCommentDetails = state => state.internalComment.commentDetails;
